var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownloadIcon = function SvgDownloadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.06 6H10V2.667C10 2.3 9.7 2 9.333 2H6.666C6.3 2 6 2.3 6 2.667V6H4.94a.669.669 0 0 0-.474 1.14l3.06 3.06c.26.26.68.26.94 0l3.06-3.06c.42-.42.127-1.14-.466-1.14Zm-7.727 6.667c0 .366.3.666.667.666h8c.366 0 .666-.3.666-.666 0-.367-.3-.667-.666-.667H4c-.367 0-.667.3-.667.667Z",
    fill: "#fff"
  })));
};
export default SvgDownloadIcon;